document.addEventListener('DOMContentLoaded', function () {
    initTermsCheckbox();
});

// Also add this to catch cases where the cart gets updated dynamically
document.addEventListener('cart:updated', initTermsCheckbox);
document.addEventListener('cart:refresh', initTermsCheckbox);

function initTermsCheckbox() {
    // Check if we've already accepted terms
    const termsAccepted = sessionStorage.getItem('tt_terms_accepted') === 'true';

    // Find the checkbox
    const termsCheckbox = document.getElementById('cart-terms-checkbox');

    if (!termsCheckbox) return; // Exit if checkbox not found

    // Auto-check the box if previously accepted
    if (termsAccepted) {
        termsCheckbox.checked = true;
    }

    // Get the cart form and checkout button
    const cartForm = document.querySelector('form[action="/cart"]');
    const checkoutButton = document.getElementById('checkout');
    const errorMsg = document.getElementById('terms-error');

    if (errorMsg) {
        errorMsg.style.display = 'none'; // Initially hide error message
    }

    if (cartForm && checkoutButton) {
        // Remove any existing listeners to prevent duplicates
        cartForm.removeEventListener('submit', validateTermsOnSubmit);

        // Add the submit event listener
        cartForm.addEventListener('submit', validateTermsOnSubmit);

        // Also add a direct click handler on the checkout button as a backup
        checkoutButton.addEventListener('click', function (e) {
            if (!termsCheckbox.checked) {
                e.preventDefault();

                if (errorMsg) {
                    errorMsg.style.display = 'block';
                }
                termsCheckbox.focus();
                termsCheckbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
                return false;
            } else {
                sessionStorage.setItem('tt_terms_accepted', 'true');
                if (errorMsg) {
                    errorMsg.style.display = 'none';
                }
            }
        });
    }
}

// Separate function for form validation
function validateTermsOnSubmit(e) {
    if (e.submitter && e.submitter.name === 'checkout') {
        const termsCheckbox = document.getElementById('cart-terms-checkbox');
        const errorMsg = document.getElementById('terms-error');

        if (termsCheckbox && !termsCheckbox.checked) {
            e.preventDefault();

            if (errorMsg) {
                errorMsg.style.display = 'block';
            }
            termsCheckbox.focus();
            termsCheckbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return false;
        } else {
            sessionStorage.setItem('tt_terms_accepted', 'true');
            if (errorMsg) {
                errorMsg.style.display = 'none';
            }
        }
    }
}